import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { HeaderProfileComponent } from '../../shared/components/header-profile/header-profile.component';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-profile-layout',
  standalone: true,
  imports: [RouterOutlet, FooterComponent, HeaderProfileComponent],
  templateUrl: './profile-layout.component.html',
  styleUrl: './profile-layout.component.scss'
})
export class ProfileLayoutComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Escuchar cambios de ruta y hacer scroll al top
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((event: NavigationEnd) => {
      // Hacer scroll al top cuando cambie la ruta
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
